(function () {
  'use strict';

  /* ---------------------------------------------------------------
     Fotky u poptavky "Obrazy na miru".

     Shopify kontaktni formular prilohy neumi, takze fotky posilame
     vedle nej na vlastni server; ten je ulozi a vrati odkazy, ktere
     vlozime do skryteho pole formulare. Majitelce prijde bezny mail
     s textem a klikacimi odkazy.

     Fotky jsou nepovinne - kdyz nahrani selze, formular se odesle dal
     a jen se do pole napise, ze se prilohy nepodarilo nahrat.

     Vsechny hlasky prichazeji z data-t-* atributu, ktere vyrenderuje
     sections/signature-poptavka.liquid ve spravnem jazyce - preklady
     jsou tim padem na jednom miste a skript je jazykove neutralni.
     --------------------------------------------------------------- */
  var API = 'https://galelie-ai-preview.vercel.app/api/poptavka';
  var MAX = 5;

  var box = document.querySelector('[data-poptavka]');
  if (!box) return;

  var input = box.querySelector('[data-poptavka-input]');
  var stav = box.querySelector('[data-poptavka-stav]');
  var nahledy = box.querySelector('[data-poptavka-nahledy]');
  var odkazyPole = box.querySelector('[data-poptavka-odkazy]');
  var formular = box.closest('form');
  if (!input || !odkazyPole) return;

  function text(jmeno, nahradni) {
    return box.getAttribute('data-t-' + jmeno) || nahradni;
  }

  var T = {
    nahravam: text('upload', 'Nahrávám fotky…'),
    jedna: text('one', '1 fotka připravená'),
    vice: text('many', 'Připravené fotky: {n}'),
    chyba: text('error', 'Fotky se nepodařilo nahrát. Poptávku klidně odešlete i tak.'),
    moc: text('limit', 'Vyberte prosím nejvýš ' + MAX + ' fotek.'),
    odesilam: text('wait', 'Ještě nahrávám fotky, moment…')
  };

  function hotovo(n) {
    return n === 1 ? T.jedna : T.vice.replace('{n}', n);
  }

  var probiha = false;

  function zprava(text, druh) {
    if (!stav) return;
    if (!text) {
      stav.hidden = true;
      stav.textContent = '';
      stav.removeAttribute('data-druh');
      return;
    }
    stav.hidden = false;
    stav.textContent = text;
    if (druh) stav.setAttribute('data-druh', druh);
    else stav.removeAttribute('data-druh');
  }

  input.addEventListener('change', function () {
    var soubory = Array.prototype.slice.call(input.files || []);
    if (!soubory.length) return;

    if (soubory.length > MAX) {
      zprava(T.moc, 'chyba');
      input.value = '';
      return;
    }

    // Nahledy hned, at navstevnik vidi, co vybral, jeste nez se nahraje.
    if (nahledy) {
      nahledy.innerHTML = '';
      nahledy.hidden = false;
      soubory.forEach(function (f) {
        var img = document.createElement('img');
        img.src = URL.createObjectURL(f);
        img.alt = f.name;
        img.onload = function () { URL.revokeObjectURL(img.src); };
        nahledy.appendChild(img);
      });
    }

    var data = new FormData();
    soubory.forEach(function (f) { data.append('foto', f); });

    probiha = true;
    zprava(T.nahravam, 'nacitani');

    fetch(API, { method: 'POST', body: data })
      .then(function (r) {
        if (!r.ok) throw new Error('stav ' + r.status);
        return r.json();
      })
      .then(function (odpoved) {
        var odkazy = (odpoved && odpoved.odkazy) || [];
        if (!odkazy.length) throw new Error('zadne odkazy');
        odkazyPole.value = odkazy.join('\n');
        zprava(hotovo(odkazy.length), 'hotovo');
      })
      .catch(function () {
        // Tahle veta jde do e-mailu majitelce, proto zustava cesky
        // bez ohledu na jazyk navstevnika.
        odkazyPole.value = 'Zákazník přikládal fotky, ale nahrání selhalo.';
        zprava(T.chyba, 'chyba');
      })
      .finally(function () {
        probiha = false;
      });
  });

  // Kdyby nekdo odeslal drive, nez se fotky nahraji.
  if (formular) {
    formular.addEventListener('submit', function (e) {
      if (probiha) {
        e.preventDefault();
        zprava(T.odesilam, 'nacitani');
      }
    });
  }
})();
